const s = "118.1.0", e = "9.50.0";
export {
  s as designSystemVersion,
  e as designTokensVersion
};
